<template>
  <w-modal
    v-model="show"
    :submit-button="$t('buttons.save')"
    :title="$t(title)"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="save()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-xs-12 col-md-7">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-5">
        <w-select :model="$schema.type" :values="types" :title="$t($schema.type.$schema.title)" @change="clearData" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <form-datepicker :model="$schema.start" :title="$t($schema.start.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <form-datepicker :model="$schema.end" :title="$t($schema.end.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-select
          :model="$schema.frequencyType"
          :values="frequencyTypes"
          :title="$t($schema.frequencyType.$schema.title)"
          @input="clearData"
        />
      </div>

      <div class="form-group col-xs-12 col-md-5" style="margin-left: 1.6em; margin-top: 2.2em;">
        <input v-model="allDay" class="custom-control-input" id="checkbox" type="checkbox" />
        <label class="custom-control-label checked" for="checkbox">Całodniowy</label>
      </div>

      <template v-if="$schema.frequencyType.$model && $schema.type.$model">
        <div v-if="$schema.frequency.$schema.fieldRequired" class="form-group  col-md-12">
          <w-input :model="$schema.frequency" :title="$t($schema.frequency.$schema.title)" />
        </div>

        <template v-if="$schema.type.$model === ScheduleType.INCLUDE">
          <div v-if="!allDay" class="form-group ol-xs-12 col-md-4">
            <w-input :model="$schema.duration" :title="$t($schema.duration.$schema.title)" />
          </div>

          <div v-if="!allDay" class="form-group col-xs-12 col-md-4">
            <w-input :model="$schema.hour" :title="$t($schema.hour.$schema.title)" />
          </div>

          <div v-if="!allDay" class="form-group col-xs-12 col-md-4">
            <w-input :model="$schema.minute" :title="$t($schema.minute.$schema.title)" />
          </div>
        </template>

        <div
          v-if="
            ($schema.day.$schema.fieldRequired && $schema.frequencyType.$model === ScheduleFrequency.WEEKLY) ||
              $schema.frequencyType.$model === ScheduleFrequency.NTH_WEEKDAY_OF_MONTH
          "
          class="form-group col-md-4"
        >
          <w-select title="Dzień tygodnia*" :model="$schema.day" :values="weekDays" />
        </div>

        <div
          v-if="
            $schema.day.$schema.fieldRequired &&
              ($schema.frequencyType.$model === ScheduleFrequency.MONTHLY ||
                $schema.frequencyType.$model === ScheduleFrequency.YEARLY)
          "
          class="form-group col-md-4"
        >
          <w-input title="Dzień miesiąca*" :model="$schema.day" />
        </div>

        <div v-if="$schema.week.$schema.fieldRequired" class="form-group col-md-4">
          <w-input :model="$schema.week" :title="$t($schema.week.$schema.title)" />
        </div>

        <div v-if="$schema.month.$schema.fieldRequired" class="form-group col-md-4">
          <w-select :model="$schema.month" :values="months" :title="$t($schema.month.$schema.title)" />
        </div>
      </template>

      <div class="form-group col-md-12">
        <w-textarea :model="$schema.description" :title="$t($schema.description.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>
<script>
import schema from '@/schemas/schedule.schema';
import { manageMixin } from '@/mixins/manage';
import { Months, MonthsTranslation } from '@/enums/month.enum';
import { Week, WeekTranslation } from '@/enums/week.enum';
import { ScheduleFrequency, ScheduleFrequencyTranslation } from '@/enums/scheduleFrequency.enum';
import { ScheduleType, ScheduleTypeTranslation } from '@/enums/scheduleType.enum';

const frequencyData = {
  frequency: 1,
  day: null,
  month: null,
  week: null,
  hour: null,
  minute: null
};

const emptyData = () => ({
  name: '',
  description: '',
  start: '',
  end: '',
  frequencyType: '',
  type: '',
  order: null,
  duration: null,
  ...frequencyData
});

// @vuese
// Modal do edycji/dodawania harmonogramów składowych
// @group Schedule
export default {
  name: 'ScheduleModal',
  schema,
  props: {
    // Harmonogram do edycji
    schedule: {
      type: Object,
      default: undefined,
      required: false
    },
    // Ilość harmonogramów składowych
    total: {
      type: Number,
      required: true
    }
  },
  mixins: [manageMixin('schedule', {}, emptyData)],
  data() {
    return {
      ScheduleType,
      ScheduleFrequency,
      allDay: false
    };
  },
  methods: {
    // @vuese
    // Czyści dane po zmianie typu harmonogramu
    clearData() {
      this.$schema.$setData({
        ...frequencyData
      });
    },
    // @vuese
    // Ustawia dane w formularzu
    setData() {
      this.$schema.$setData(this.id !== undefined ? this.schedule : emptyData());
      this.$schema.$reset();
    },
    // @vuese
    // Funkcja waliduje formularz, i zapisuje/nadpisuje dane w bazie
    save() {
      this.$schema.$setData({
        order: this.$schema.order.$model ? this.$schema.order.$model : this.total
      });
      if (!this.$schema.$validateAll().length) {
        if (this.id !== undefined) {
          // Emituje event do edytowania danych
          // @arg Zwalidowany model do edycji w bazie
          this.$emit('update', this.model);
        } else {
          // Emituje event do zapisu danych
          // @arg Zwalidowany model do utworzenia w bazie
          this.$emit('save', this.model);
        }
        this.close();
      } else {
        this.notifyError('messages.form.error');
      }
    }
  },
  computed: {
    months() {
      return Object.keys(Months)
        .filter(key => !isNaN(key))
        .map(month => ({
          value: month,
          text: this.$t(MonthsTranslation[month])
        }));
    },
    weekDays() {
      const days = Object.keys(Week)
        .filter(key => !isNaN(key))
        .map(weekDay => ({
          value: weekDay,
          text: this.$t(WeekTranslation[weekDay])
        }));
      const sunday = days.shift();
      days.push(sunday);
      return days;
    },
    frequencyTypes() {
      return Object.keys(ScheduleFrequency).map(frequencyType => ({
        value: ScheduleFrequency[frequencyType],
        text: this.$t(ScheduleFrequencyTranslation[ScheduleFrequency[frequencyType]])
      }));
    },
    types() {
      return Object.keys(ScheduleType).map(type => ({
        value: ScheduleType[type],
        text: ScheduleTypeTranslation[ScheduleType[type]]
      }));
    },
    title() {
      return this.id !== undefined ? 'modals.schedule-edit' : 'modals.schedule-add';
    }
  },
  watch: {
    allDay(val) {
      if (val) {
        this.$schema.$setData({
          duration: 1440,
          hour: 0,
          minute: 0
        });
      }
    },
    show(val) {
      if (val) {
        this.allDay = this.$schema.duration.$model === 1440;
      }
    }
  }
};
</script>

<style scoped>
.checked::after {
  background-size: 50% 50%;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
}
</style>
